// src/components/AvailabilityChips.tsx
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";
import { summarizeAvailability } from "@/lib/availabilitySummary";
import type { Interval } from "@/lib/availability";

export default function AvailabilityChips({
  windows,
  hasRows,
}: { windows: Interval[]; hasRows: boolean }) {
  if (!hasRows) {
    // Værten har ikke sat specifikke dage
    return (
      <Badge variant="outline" className="text-xs">
        <Calendar className="h-3 w-3 mr-1" />
        Ingen specifikke dage angivet
      </Badge>
    );
  }

  const { chips } = summarizeAvailability(windows, 30);
  const toneToClass = {
    success: "bg-success text-success-foreground border-transparent",
    muted: "text-muted-foreground",
    default: "",
  } as const;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((c, i) => (
        <Badge
          key={i}
          variant="outline"
          className={`text-xs ${toneToClass[(c.tone ?? "default") as keyof typeof toneToClass]}`}
        >
          <Calendar className="h-3 w-3 mr-1" />
          {c.text}
        </Badge>
      ))}
    </div>
  );
}
